// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"12e2f247","249":"06778fad","283":"929c369a","298":"88dd889c","996":"c8be8685"}[chunkId] + ".chunk.js";
};